import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { VersionService } from '../../../core/services/version/version.service';

interface LatestVersionResponse {
  id: string;
  versionName: string; // "v0.1.0"
  versionNumber: string; // "0.1.0" - backend might return logic
  developmentStage: number;
  releaseDate: string;
}

@Component({
  selector: 'app-welcome-image',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './welcome-image.component.html',
  styleUrl: './welcome-image.component.scss',
})
export class WelcomeImageComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  latestVersion: string = 'v0.1.0'; // Default fallback

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private versionService: VersionService
  ) {
    const userLang = localStorage.getItem('app-lang') || 'en-US';
    this.translate.use(userLang);
  }

  ngOnInit(): void {
    this.versionService.version$.subscribe(v => {
      if (v) this.latestVersion = v;
    });
  }
}
